const App = {
  main: "/",
  login: "/login",
  help: "/pomoc",
  searchList: "/wynik-wyszukiwania-projektow",
  termOfUse: "/regulamin",
  legalDocument: "/deklaracja-dostepnosci",
  redirectUri: "/authentication/callback",
  silentRedirectUri: "/authentication/silent_callback",
  notFound: "/nie-znaleziono",
};
const Consultation = {
  default: "/konsultacje",
  list: {
    actual: "/aktualne-konsultacje",
    finished: "/zakonczone-konsultacje",
  },
  preview: "/konsultacje/podglad",
  previewFunc: (id) => `/konsultacje/podglad/${id}`,
  vote: "/konsultacje/zaglosuj",
  voteFunc: (id) => `/konsultacje/zaglosuj/${id}`,
};
const Survey = {
  default: "/ankiety",
  list: {
    actual: "/aktualne-ankiety",
    finished: "/zakonczone-ankiety",
  },
  preview: "/ankiety/podglad",
  previewFunc: (id) => `/ankiety/podglad/${id}`,
  vote: "/ankiety/zaglosuj",
  voteFunc: (id) => `/ankiety/zaglosuj/${id}`,
};
const Probe = {
  default: "/sondy",
  list: {
    actual: "/aktualne-sondy",
    finished: "/zakonczone-sondy",
  },
  detail: "/sondy/szczegoly",
  detailFunc: (id) => `/sondy/szczegoly/${id}`,
  preview: "/sondy/podglad",
  vote: "/sondy/zaglosuj",
  voteFunc: (id) => `/sondy/zaglosuj/${id}`,
};
const Budget = {
  default: "/budzet",
  list: {
    actual: "/aktualny-budzet",
    finished: "/zakonczone-budzety",
  },
  projectTasks: {
    listForYear: (budgetYearId) =>
      `/budzet/lista-projektow-budzetu?budgetYearId=${budgetYearId}`,
    acceptedListForYear: (budgetYearId) =>
      `/budzet/lista-projektow-budzetu?budgetYearId=${budgetYearId}&districtId=-1&officeThematicAreaId=-1&status=3&searchTerm=&page=1&size=10`,
    list: "/budzet/lista-projektow-budzetu",
    map: "/budzet/mapa-projektow-budzetu",
    preview: "/budzet/podglad-projektu-budzetu",
    previewFunc: (id) => `/budzet/podglad-projektu-budzetu/${id}`,
  },
  pages: {
    schedule: "/budzet/:budgetYearValue/harmonogram",
    scheduleFunc: (budgetYearValue) => `/budzet/${budgetYearValue}/harmonogram`,
    help: "/budzet/:budgetYearValue/pomoc",
    helpFunc: (budgetYearValue) => `/budzet/${budgetYearValue}/pomoc`,
    prerequisite: "/budzet/:budgetYearValue/do-pobrania",
    prerequisiteFunc: (budgetYearValue) =>
      `/budzet/${budgetYearValue}/do-pobrania`,
  },
  vote: {
    list: {
      actual: "/budzet/:budgetYearValue/aktualne-glosowania",
      actualFunc: (budgetYearValue) =>
        `/budzet/${budgetYearValue}/aktualne-glosowania`,
      finished: "/budzet/:budgetYearValue/zakonczone-glosowania",
      finishedFunc: (budgetYearValue) =>
        `/budzet/${budgetYearValue}/zakonczone-glosowania`,
    },
    preview: "/budzet/:budgetYearValue/glosowania/podglad/:id",
    previewFunc: (budgetYearValue, id) =>
      `/budzet/${budgetYearValue}/glosowania/podglad/${id}`,
    vote: "/budzet/:budgetYearValue/glosowania/zaglosuj/:id",
    voteFunc: (budgetYearValue, id) =>
      `/budzet/${budgetYearValue}/glosowania/zaglosuj/${id}`,
    result: "/budzet/:budgetYearValue/:id/wyniki",
    resultFunc: (budgetYearValue, id) =>
      `/budzet/${budgetYearValue}/${id}/wyniki`,
  },
};
const Initiative = {
  default: "/inicjatywy",
};
const Meeting = {
  list: "/spotkania-bezposrednie",
};
const User = {
  list: "/uzytkownicy",
  create: "/uzytkownicy/utworz-nowego",
  edit: "/uzytkownicy/edytuj",
};
const Comment = {
  listFunc: (projectId) => `/komentarze/${projectId}`,
};

export const RouteUrls = {
  App,
  Consultation,
  Survey,
  Probe,
  Budget,
  Initiative,
  Meeting,
  User,
  Comment,
};
